import { Controller } from "@hotwired/stimulus"

// Handles lazy loading of NOTAM details when Bootstrap collapse is opened.
// The turbo-frame has data-src instead of src, so it doesn't load until we set src.
export default class extends Controller {
  static targets = ["collapse"]

  connect() {
    this.collapseTargets.forEach(collapse => {
      collapse.addEventListener('show.bs.collapse', this.loadFrame.bind(this))
    })
  }

  disconnect() {
    this.collapseTargets.forEach(collapse => {
      collapse.removeEventListener('show.bs.collapse', this.loadFrame.bind(this))
    })
  }

  loadFrame(event) {
    const collapse = event.target
    const frame = collapse.querySelector('turbo-frame')

    if (frame && !frame.hasAttribute('src') && frame.dataset.src) {
      // Set the src attribute to trigger the Turbo Frame load
      frame.setAttribute('src', frame.dataset.src)
    }
  }
}
